import React from "react";
import "./AudioRecorder.css";
import { micRecording } from "../../../NewConstants/RecorderConstant";
import LoadingDots from '../LoadingDots/LoadingDots';
import MicWaveAnimation from "../MicWaveAnimation/MicWaveAnimation";


const AudioRecorder = ({selectedLanguageCode, showLoader, onStop = () => {}, onCancelRecording = () => {} }) => {

  return (
    <>
      <div className="z-30 fixed inset-0 bg-gray-800 opacity-50"></div>
      <div className="z-30 bg-[var(--neutral-white)] fixed left-0 bottom-0 w-full rounded-t-3xl flex flex-col p-0 justify-between recorederBox pb-safe">
      <div className="flex justify-between">
          <div className="flex flex-col gap-2 p-6">
            <div className="text-2xl font-semibold text-[color:var(--dark-neutral-text)]">
              {micRecording.title[selectedLanguageCode]}
            </div>
            <div className="text-xl font-normal text-[color:var(--dark-neutral-2)]">
              {micRecording.subtitle[selectedLanguageCode]}
            </div>
          </div>
          <div className="flex items-start justify-end pt-6 pr-6 ">
            <button
              className="audio-close-btn"
              onClick={onCancelRecording}
              aria-label="Close"
            >
              <svg
                width="44"
                height="43"
                viewBox="0 0 44 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.1477 14.4502L14.0492 28.5487"
                  stroke="var(--red-1)"
                  stroke-width="3.20993"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.0492 14.4502L28.1477 28.5487"
                  stroke="var(--red-1)"
                  stroke-width="3.20993"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-2 items-center justify-between pb-4">
          <MicWaveAnimation />
          {!showLoader ? 
            <div className="bg-[var(--primary-dark)] w-[90%] rounded-lg py-3.5 px-5 text-[color:var(--neutral-white)] flex items-center justify-center text-center gap-3" onClick={onStop}>
              <div className="w-3 h-3 bg-[var(--neutral-white)]"></div>
              {micRecording.stop[selectedLanguageCode]}
              
            </div> :
            <div className="bg-[var(--primary-dark)] w-[90%] rounded-lg py-3.5 px-5 text-[color:var(--neutral-white)] flex items-center justify-center text-center gap-3">
              <div className="h-6 flex items-center">
                <LoadingDots />
              </div>
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default AudioRecorder;

